import { EDITOR_MODES, VIEW_MODES } from 'crazyEditor/core/constants/editorConstants';
import { LOCATION_CHANGE } from 'react-router-redux';
const SET_MOBILE_OVERFLOW = 'crazyEditor/editor/SET_MOBILE_OVERFLOW';
const UPDATE_MOBILE_VIEW = 'crazyEditor/editor/UPDATE_MOBILE_VIEW';
const UPDATE_MOBILE_VIEW_SUCCESS = 'crazyEditor/editor/UPDATE_MOBILE_VIEW_SUCCESS';
const SAVE = 'crazyEditor/editor/SAVE';
export const SAVE_SUCCESS = 'crazyEditor/editor/SAVE_SUCCESS';
const SAVE_FAIL = 'crazyEditor/editor/SAVE_FAIL';
const CLEAR_SAVE_ERROR = 'crazyEditor/editor/CLEAR_SAVE_ERROR';
const RESTART_WALK_THROUGH = 'crazyEditor/editor/RESTART_WALK_THROUGH';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case LOCATION_CHANGE:
      const mode = action.payload.query.mode;
      const view = action.payload.query.view;
      const isPreviewMode = mode === EDITOR_MODES.PREVIEW || mode === EDITOR_MODES.QUICK_PREVIEW;
      const isMobileView = view === VIEW_MODES.MOBILE;
      return {
        ...state,
        viewMode: view || VIEW_MODES.DESKTOP,
        isMobileView: isMobileView,
        isDesktopView: view !== VIEW_MODES.MOBILE,
        editorMode: mode || EDITOR_MODES.EDITOR,
        isPreviewMode,
        isQuickPreviewMode: mode === EDITOR_MODES.QUICK_PREVIEW,
        isEditorMode: !isPreviewMode,
        shouldUpdateMobileView: !state.isMobileVeiew && isMobileView,
      };
    case UPDATE_MOBILE_VIEW:
      return {
        ...state,
        shouldUpdateMobileView: true
      };
    case UPDATE_MOBILE_VIEW_SUCCESS:
      return {
        ...state,
        shouldUpdateMobileView: false
      };
    case SET_MOBILE_OVERFLOW:
      return {
        ...state,
        mobileOverflow: action.flag
      };
    case SAVE:
      return {
        ...state,
        saving: true
      };
    case SAVE_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
        saveSuccess: true,
        saveError: null,
      };
    case SAVE_FAIL:
      return {
        ...state,
        saving: false,
        saved: false,
        saveSuccess: false,
        saveError: action.error
      };
    case CLEAR_SAVE_ERROR:
      return {
        ...state,
        saving: false,
        saveError: null
      };
    case RESTART_WALK_THROUGH:
      return {
        ...state,
        walkThroughKey: state.walkThroughKey + 1
      };
    default:
      return state;
  }
}

export function updateMobileView() {
  return {type: UPDATE_MOBILE_VIEW};
}

export function updateMobileViewSuccess() {
  return {type: UPDATE_MOBILE_VIEW_SUCCESS};
}

export function setMobileOverflow(flag) {
  return {type: SET_MOBILE_OVERFLOW, flag};
}

export function saveSite() {
  return {type: SAVE};
}

export function saveSiteSuccess() {
  return {type: SAVE_SUCCESS};
}

export function saveSiteFail(error) {
  return {type: SAVE_FAIL, error};
}

export function clearSaveError() {
  return {type: CLEAR_SAVE_ERROR};
}

export function restartWalkThrough() {
  return {type: RESTART_WALK_THROUGH};
}

